import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default class ComboSlot extends ItemsV3Serializer {
  normalize(type, data) {
    // name was being initialized as undefined when it was not provided
    data.name = data.name ?? null;
    return super.normalize(type, data);
  }
}